import React from 'react'
import CrossIcon from '@tecuity/sos-icons/react/cross-heavy'
import './Toast.scss'
import { connect } from 'react-redux'
import { clearErrorToast, clearSuccessToast } from '../../actions'

class Toast extends React.Component{
  static defaultProps = {
    timeout: 5000
  }
  state = {
    animationClass: 'float-in-up',
    exiting: false,
    message: this.props.message,
    visible: this.props.message ? true : false
  }
  timer = null;
  componentDidMount = () => {
    if(this.state.visible){
      this.startTimer()
    }
  }
  startTimer = () => {
    if(!this.props.isPersistent){
      this.cancelTimer()
      this.timer = window.setTimeout(this.startExiting, this.props.timeout)
    }
  }
  cancelTimer = () => {
    window.clearTimeout(this.timer)
  }
  
  componentDidUpdate(prevProps, prevState, snapshot) {
    if(!this.props.manual && this.props.message !== prevState.message){
      this.setState({
        message: this.props.message,
        animationClass: 'float-in-up',
        visible: true
      })
      this.startTimer()
    }
  }
  startExiting = () => {
    if(this.props.message){
      this.setState({
        animationClass: 'float-out-down',
        exiting: true
      })
    }
    this.cancelTimer()
  }
  dismiss = () => {
    if(this.state.exiting === true){
      this.setState({
        visible: false,
        exiting: false,
        message: null
      })
      this.cancelTimer()
      this.props.danger && this.props.clearErrorToast()
      this.props.success && this.props.clearSuccessToast()
    }
  }
  trigger = () => {
    this.cancelTimer();
    this.setState({
      message: this.props.message,
      animationClass: 'float-in-up',
      visible: true,
      exiting: false
    })
    this.startTimer()
  }
  render(){
    const { message, danger, success } = this.props;
    return(
      this.state.visible && message ?
      <div className={`toast-wrapper ${this.state.animationClass}`} onAnimationEnd={this.dismiss}>
        <div className={`toast ${danger ? 'danger' : ''} ${success ? 'success' : ''}`} onMouseEnter={this.cancelTimer} onMouseLeave={this.startTimer}>
          <span className='message'>{message}</span>
          <button className='dismiss-btn' onClick={this.startExiting}><CrossIcon/></button>
        </div>
      </div>
      : null
    )
  }
}
export default connect((state) => {return {isPersistent: state.app.toastIsPersistent} }, {clearErrorToast, clearSuccessToast})(Toast)


// WEBPACK FOOTER //
// ./src/components/Toast/Toast.js